export default __webpack_public_path__ + "static/media/gpp-white.89f4a4eb.svg";